/**
 * Hook tải chi tiết một bất động sản theo id (trang detail công khai).
 */
import { useEffect, useState } from 'react';
import { propertyApi } from '../api/propertyApi';

/**
 * Fetch và giữ state chi tiết tin BĐS; tự fetch lại khi propertyId đổi.
 *
 * @param {string|number} propertyId - Id tin cần xem.
 * @returns {{ selectedProperty: Object|null, isLoadingProperty: boolean }}
 */
export const usePropertyDetails = (propertyId) => {
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [isLoadingProperty, setIsLoadingProperty] = useState(true);

  useEffect(() => {
    let isMounted = true;

    setIsLoadingProperty(true);
    propertyApi
      .getProperty(propertyId)
      .then((response) => {
        if (isMounted) {
          setSelectedProperty(response.data.data);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoadingProperty(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [propertyId]);

  return {
    selectedProperty,
    isLoadingProperty,
  };
};
